export const DEFAULT_IN_APP_MODAL_BADGE_LABEL = "New Feature";
export const DEFAULT_IN_APP_MODAL_BADGE_THEME = "blue";
export const DEFAULT_IN_APP_MODAL_DESIGN = "modal_1";

export const IN_APP_MODAL_DESIGN_OPTIONS = [
  { value: "modal_1", label: "Modal 1" },
  { value: "modal_2", label: "Modal 2" },
];

export const IN_APP_MODAL_BADGE_THEME_OPTIONS = [
  {
    value: "blue",
    label: "Blue",
    color: "#3974CC",
    backgroundColor: "rgba(57, 116, 204, 0.10)",
    borderColor: "rgba(57, 116, 204, 0.18)",
    darkColor: "#93C5FD",
    darkBackgroundColor: "rgba(59, 130, 246, 0.18)",
    darkBorderColor: "rgba(147, 197, 253, 0.30)",
  },
  {
    value: "green",
    label: "Green",
    color: "#15803D",
    backgroundColor: "rgba(22, 163, 74, 0.12)",
    borderColor: "rgba(22, 163, 74, 0.20)",
    darkColor: "#86EFAC",
    darkBackgroundColor: "rgba(34, 197, 94, 0.16)",
    darkBorderColor: "rgba(134, 239, 172, 0.28)",
  },
  {
    value: "amber",
    label: "Amber",
    color: "#B45309",
    backgroundColor: "rgba(245, 158, 11, 0.14)",
    borderColor: "rgba(245, 158, 11, 0.22)",
    darkColor: "#FCD34D",
    darkBackgroundColor: "rgba(245, 158, 11, 0.16)",
    darkBorderColor: "rgba(252, 211, 77, 0.30)",
  },
  {
    value: "rose",
    label: "Rose",
    color: "#BE123C",
    backgroundColor: "rgba(244, 63, 94, 0.12)",
    borderColor: "rgba(244, 63, 94, 0.20)",
    darkColor: "#FDA4AF",
    darkBackgroundColor: "rgba(244, 63, 94, 0.16)",
    darkBorderColor: "rgba(253, 164, 175, 0.30)",
  },
  {
    value: "violet",
    label: "Violet",
    color: "#6D28D9",
    backgroundColor: "rgba(124, 58, 237, 0.12)",
    borderColor: "rgba(124, 58, 237, 0.20)",
    darkColor: "#C4B5FD",
    darkBackgroundColor: "rgba(124, 58, 237, 0.18)",
    darkBorderColor: "rgba(196, 181, 253, 0.32)",
  },
];

const validBadgeTheme = (value) => (
  IN_APP_MODAL_BADGE_THEME_OPTIONS.some((theme) => theme.value === value)
    ? value
    : DEFAULT_IN_APP_MODAL_BADGE_THEME
);

const validModalDesign = (value) => (
  IN_APP_MODAL_DESIGN_OPTIONS.some((design) => design.value === value)
    ? value
    : DEFAULT_IN_APP_MODAL_DESIGN
);

export const getInAppModalConfig = (metadata = {}) => {
  const nested = metadata?.inAppModal || metadata?.in_app_modal || {};

  return {
    enabled: Boolean(
      nested?.enabled ??
      metadata?.inAppModalEnabled ??
      metadata?.in_app_modal_enabled
    ),
    buttonLabel:
      nested?.buttonLabel ||
      nested?.button_label ||
      metadata?.inAppModalButtonLabel ||
      metadata?.in_app_modal_button_label ||
      "",
    design: validModalDesign(
      nested?.design ||
      nested?.modalDesign ||
      nested?.modal_design ||
      metadata?.inAppModalDesign ||
      metadata?.in_app_modal_design ||
      metadata?.modal_design ||
      DEFAULT_IN_APP_MODAL_DESIGN
    ),
    badgeLabel:
      nested?.badgeLabel ||
      nested?.badge_label ||
      nested?.modalBadgeText ||
      nested?.modal_badge_text ||
      metadata?.inAppModalBadgeLabel ||
      metadata?.in_app_modal_badge_label ||
      metadata?.modal_badge_text ||
      DEFAULT_IN_APP_MODAL_BADGE_LABEL,
    badgeTheme: validBadgeTheme(
      nested?.badgeTheme ||
      nested?.badge_theme ||
      metadata?.inAppModalBadgeTheme ||
      metadata?.in_app_modal_badge_theme ||
      metadata?.badge_theme ||
      DEFAULT_IN_APP_MODAL_BADGE_THEME
    ),
    examplePrompt:
      nested?.examplePrompt ||
      nested?.example_prompt ||
      metadata?.inAppModalExamplePrompt ||
      metadata?.in_app_modal_example_prompt ||
      metadata?.example_prompt ||
      "",
  };
};

export const isInAppModalNotification = (notification) =>
  Boolean(getInAppModalConfig(notification?.metadata || {}).enabled);
